import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

import ModalContent from '../components/ModalContent';
import ModalView from '../components/ModalView';

export default class TemplateCollection {
  constructor({ el }) {
    this.$el = $(el);
    this._bindEvents();
    this.validate();
  }

  _bindEvents() {
    this.events = [
      $('.collection-filter select', this.$el).on('change.collection', event => this.updateFilter(event)),
      $('.collection-sorting select', this.$el).on('change.collection', event => this.sortProducts(event)),
      $('.collection-remove-filter', this.$el).on('click.collection', event => this.resetFilter(event)),
      $('.collection-description-more', this.$el).on('click.collection', event => this.createModal(event)),
      $('.collection-sharing-toggle', this.$el).on('click.collection', event => this.toggleSharing(event)),
      $('.share-buttons', this.$el).on('mouseout.collection', event => this.toggleSharing(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.collection'));
  }

  validate() {
    this.section = window.sectionJSON;
    this.tagsWrapper = $('.collection-tags-wrapper', this.$el);
    this.tags = this.tagsWrapper.find('.collection-tags', this.$el);
    this.tagFilter = $('.collection-tags-apply', this.$el);

    if ($('html').hasClass('lt-ie9') && $('.collection-header', this.$el).length) {
      this.verticallyAlignHeaderText();
    }
    if (this.section.collection_filtering) {
      this.filterProducts();
    }

    if ($('.collection-products', this.$el).data('layout') === 'masonry') {
      this.masonryLayout();
    }
  }

  verticallyAlignHeaderText() {
    const headerHeight = $('.collection-details', this.$el).height();
    $('.collection-details', this.$el).css({ marginTop: -(headerHeight / 2) });
  }

  toggleSharing(e) {
    if (e.type === 'mouseout') {
      if ($(e.relatedTarget).closest('.share-buttons').length) { return; }
    }

    $('.collection-sharing', this.$el).toggleClass('active');
  }

  sortProducts(e) {
    let search;
    const Sorting = {};
    Sorting.sort_by = $('.collection-sorting select', this.$el).val();

    if ($(e.target).closest('.collection-sorting').hasClass('vendor-collection')) {
      const currentSearch = location.search;
      const searchParts = currentSearch.split('&');

      for (let index = 0; index < searchParts.length; index++) {
        const part = searchParts[index];
        if (part.indexOf('sort_by') !== -1) {
          searchParts.splice(index, 1);
        }
      }

      search = searchParts.join('&');
      location.search = `${search}&${$.param(Sorting)}`;
    }
    location.search = $.param(Sorting);
  }

  masonryLayout() {
    const $products = $('.collection-products', this.$el);

    if ($('.product-list-item', this.$el).length) {
      imagesLoaded($products[0], () => {
        this.events.push($products.one('layoutComplete', () => $products.addClass('processed')));
        new Masonry($products[0], { transitionDuration: 0 });
      });
    } else {
      $products.addClass('processed empty-collection');
    }
  }

  filterProducts() {
    this.fallbackURL = $('.collection-filtering', this.$el).data('fallback-url');

    $('.collection-filter select', this.$el).each((index, filter) => {
      if ($(filter).val() !== 'any') {
        const selectedText = $(filter).find('option:selected').text();
        $(filter).prev().find('strong').text(selectedText);
      }
    });
  }

  updateFilter(e) {
    const newTags = [];

    $(e.target).toggleClass('active');

    $('.collection-filter select', this.$el).each((index, filter) => {
      if ($(filter).val() !== 'any') {
        const tag = $(filter).val();
        newTags.push(tag);
      }
    });

    if (newTags.length) {
      const tags = newTags.join('+');

      const filterURL = `${this.fallbackURL}/${tags}`;
      window.location.href = filterURL;
    } else {
      this.resetFilter();
    }
  }

  resetFilter() {
    const fallback = `${this.fallbackURL}${location.search}`;
    window.location.href = fallback;
  }

  createModal() {
    const modalContent = new ModalContent({
      title: collectionJSON.title,
      message: collectionJSON.body_html,
    });

    new ModalView({
      model: modalContent,
      el: $('.modal-wrapper'),
    });
  }

  onSectionUnload() {
    this._unbindEvents();
  }
}
